import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { ReactComponent as CheckLogo } from "../../assets/images/check-circle.svg";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
  autoClose?: boolean; // optional prop for flexibility
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "Confirmation",
  message,
  onClose,
  onConfirm,
  autoClose = true,
}) => {
  

  return (
    <Dialog
      open={open}
      // Prevent close on outside click / backdrop
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          padding: "16px",
          maxWidth: "300px",
          width: "100%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      {/* Image in center */}
      <DialogTitle sx={{ display: "flex", justifyContent: "center", p: 0 }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 2 }}
        >
          <CheckLogo
            style={{ width: "80px", height: "80px", color: "#4caf50" }}
          />
        </Box>
      </DialogTitle>

      {/* Message */}
      <DialogContent
        sx={{ padding: "16px 24px", textAlign: "center", marginTop: "30px" }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
          {message}
        </Typography>
      </DialogContent>

      {/* Buttons */}
      <DialogActions
        sx={{
          justifyContent: "center",
          padding: "6px 24px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            padding: "8px 24px",
            color: "#ffffff",
            fontWeight: "500",
            backgroundColor: "#009DFF",
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
